import { createReference } from "@knyt/artisan";
/**
 * HostMonitor tracks the connection and update status of a host.
 *
 * @remarks
 *
 * An instance must be added to a host during it construction for
 * it to accurately track the host's status.
 *
 * @beta This is an experimental API. It may change in future versions.
 */
export class HostMonitor {
    #isHostConnected$ = createReference(false);
    #isHostUpdating$ = createReference(false);
    #hasHostConnected$ = createReference(false);
    #hasHostUpdated$ = createReference(false);
    isHostConnected$ = this.#isHostConnected$.asReadonly();
    isHostUpdating$ = this.#isHostUpdating$.asReadonly();
    hasHostConnected$ = this.#hasHostConnected$.asReadonly();
    hasHostUpdated$ = this.#hasHostUpdated$.asReadonly();
    get isHostConnected() {
        return this.#isHostConnected$.value;
    }
    get isHostUpdating() {
        return this.#isHostUpdating$.value;
    }
    get hasHostConnected() {
        return this.#hasHostConnected$.value;
    }
    get hasHostUpdated() {
        return this.#hasHostUpdated$.value;
    }
    constructor(host) {
        host.addController(this);
    }
    hostConnected() {
        this.#isHostConnected$.set(true);
        if (!this.#hasHostConnected$.value) {
            this.#hasHostConnected$.set(true);
        }
    }
    hostDisconnected() {
        this.#isHostConnected$.set(false);
    }
    hostUpdate() {
        this.#isHostUpdating$.set(true);
        if (!this.#hasHostUpdated$.value) {
            this.#hasHostUpdated$.set(true);
        }
    }
    hostUpdated() {
        this.#isHostUpdating$.set(false);
    }
}
